export const environment = {
    production: true,
    appInsights: {
      instrumentationKey: 'da3187d3-b51b-49c1-9435-ab363910f379',
    },
    apiurl:'https://rs-etlapi-a.azurewebsites.net/',
    realizerUrl: 'https://rs-realizerapi-a.azurewebsites.net/',
    scopes:'https://RemoteServiceADAUTO.onmicrosoft.com/api/access_as_user',
    b2cConfig:{
      clientId:"4114f2fb-49d8-4ab3-9f43-27b627c2122f",
      authority:'https://RemoteServiceADAUTO.b2clogin.com/RemoteServiceADAUTO.onmicrosoft.com/B2C_1A_signup_signin',
      authorityDomain:'RemoteServiceADAUTO.b2clogin.com'
    }
  };
  